<style lang="scss" >
.v-alert.error {
  background-color: #ef6868;
}
#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}
.v-speed-dial__list {
  width: 0;
  left: 14%;
}

/* custom-search */
.custom-search .v-text-field__slot input {
  border-bottom: none !important;
  padding: 5px 12px !important;
  margin: 0 !important;
}

.custom-search .v-label {
  padding: 0 12px;
  top: 12px;
}

.custom-search .v-text-field__slot input:focus {
  border-bottom: none !important;
  box-shadow: none !important;
}
</style>

<template lang="pug">
.main-content-padded
  .vspace.large
  .row
    .col.s12
      .bcrumb
        router-link(:to='{ path: "/discount" }') Discount
        a {{ pdList.name }}
  .row
    .col.s12
      router-link.btn.mb-4(
        :to='{ name: "add-discount-product", params: { addpdList: pdList, inventoryID: shop } }'
      )
        | Add New
      v-card
        v-card-title
          | {{ pdList.name }}
          v-spacer
          v-text-field.custom-search.mb-0(
            v-model='search',
            append-icon='search',
            label='Search',
            single-line='',
            hide-details=''
          )
        v-data-table(:headers='headers', :items='productlst', :search='search')
          template(slot='items', slot-scope='props')
            td {{ props.item.variantCode }}
            td PHP {{ Number(props.item.price) | convert }}
            td PHP {{ props.item.saleDiscount | convert }}
            td PHP {{ props.item.sale | convert }}
            td
              a
                i.material-icons.red-text(@click='confirmDelete(props.item)') delete
          v-alert(
            slot='no-results',
            :value='true',
            color='red',
            icon='warning'
          )
            | Your search for &quot;{{ search }}&quot; found no results.
</template>
<script>
import DataTable from 'vue-materialize-datatable'
import AlertModalContent from 'inomph-common/dist/components/alert-modal-content'

export default {
  data () {
    return {
      shop: [],
      discountDetail: [],
      discountProductList: [],
      search: '',
      selected: [],
      pagination: {
        sortBy: 'name'
      },
      headers: [
        { text: 'Product Varient', value: 'variantCode', align: 'left' },
        { text: 'Original Price', value: 'price', align: 'left' },
        { text: 'Less Amount', value: 'saleDiscount', align: 'left' },
        { text: 'Sale Price', value: 'sale', align: 'left' },
        { text: 'Actions', value: '', align: 'left' }
      ],
      direction: 'right',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: false,
      left: false,
      transition: 'slide-y-reverse-transition'
    }
  },
  computed: {
    activeFab () {
      switch (this.tabs) {
        // case 'one': return { 'class': 'purple', icon: 'account_circle' }
        case 'two':
          return { class: 'red', icon: 'edit' }
        case 'three':
          return { class: 'green', icon: 'keyboard_arrow_up' }
        default:
          return {}
      }
    },
    pdList () {
      return this.$route ? this.$route.params.pdList : null
    },
    supplier () {
      return this.$store.state.profile.supplier
    },
    productlst () {
      // return this.discountProductList
      var formatted = []
      var i
      let disamount = this.discountDetail['amount']
      if (this.discountDetail['discountType'] === 'fix') {
        for (i = 0; i < this.discountProductList.length; i++) {
          formatted[i] = {
            variantCode: this.discountProductList[i]['variantCode'],
            price: this.discountProductList[i]['price'],
            saleDiscount: Number(disamount),
            sale:
              Number(this.discountProductList[i]['price']) - Number(disamount),
            discountId: this.pdList['id'],
            productVariantId: this.discountProductList[i]['id']
          }
        }
        return formatted
      } else {
        let percentAmount = Number(disamount) / 100
        for (i = 0; i < this.discountProductList.length; i++) {
          var salepercent
            = Number(this.discountProductList[i]['price']) * percentAmount
          var saleTotal
            = Number(this.discountProductList[i]['price']) - salepercent
          formatted[i] = {
            variantCode: this.discountProductList[i]['variantCode'],
            price: this.discountProductList[i]['price'],
            saleDiscount: salepercent,
            sale: saleTotal,
            discountId: this.pdList['id'],
            productVariantId: this.discountProductList[i]['id']
          }
        }
        return formatted
      }
    }
  },
  mounted () {
    this.getDiscountedProductList()
    this.getShopByName()
  },
  methods: {
    getShopByName () {
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        this.$http
          .get(`${this.$config.API_URL}/suppliers/${this.supplier.id}/shops`, {
            params: {
              code: this.$route.params.shopCode
            },
            headers: {
              authorization: `Bearer ${accessToken}`
            }
          })
          .then((result) => {
            this.shop = result.data
          })
      })
    },
    getDiscountedProductList () {
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        return this.$http
          .get(
            `${this.$config.API_URL}/suppliers/discount/discounted-product/${this.pdList.id}`,
            {
              headers: {
                Authorization: 'Bearer ' + accessToken
              }
            }
          )
          .then((result) => {
            this.discountProductList = result.data['productVariants']
            this.discountDetail = result.data['details']
          })
      })
    },
    confirmDelete (dID) {
      const modalParams = {
        content: AlertModalContent,
        style: { padding: 'medium' },
        bind: {
          title: `Delete ${dID.variantCode} discount?`,
          message: 'This cannot be undone.',
          positiveButton: {
            message: 'Delete',
            onClick: this.deleteItem.bind(this, dID)
          },
          negativeButton: {
            message: 'Cancel',
            onClick: () => {
              this.modal.close()
            }
          }
        }
      }
      this.$store.dispatch('modal/open', modalParams).then((modal) => {
        this.modal = modal
      })
    },
    deleteItem (disProduct) {
      let data = [
        {
          discountId: disProduct.discountId,
          productVariantId: disProduct.productVariantId
        }
      ]
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        this.$http
          .delete(
            `${this.$config.API_URL}/suppliers/discount/remove-discounted-product`,
            {
              data: data,
              headers: {
                authorization: `Bearer ${accessToken}`
              }
            }
          )
          .then(() => {
            this.$snackbar.success('Discounted Product deleted')
            this.getDiscountedProductList()
          })
          .catch((err) => {
            this.$snackbar.error(
              'Unable to delete Discounted Product: ' + err.message
            )
          })
          .then(() => {
            this.getDiscountedProductList()
            this.$store.dispatch('modal/close')
          })
      })
    },
    here (val, pid) {},
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.productlst.slice()
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  },
  filters: {
    convert: function (value) {
      return value.toFixed(2)
    }
  },
  components: {
    datatable: DataTable
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-discount-products.vue